import useTermAutocomplete from './useTermAutocomplete';

export default useTermAutocomplete;
